<template>
    <div>
        <Header title="测评配置" memo="管理测评配置数据"></Header>
        <a-divider />
        <a-tabs default-active-key="1" @change="onTabsChange">
            <a-tab-pane key="1" tab="计分规则">
                <a-form-model :model="score">
                    <table class="bordered">
                        <thead>
                            <tr>
                                <th style="width: 20%;">
                                    项目
                                </th>
                                <th style="width: 80%;">
                                    效率分B
                                </th>
                            </tr>
                        </thead>
                        <tr>
                            <td>
                                注意分配
                            </td>
                            <td>
                                B1=
                                <a-input type="number" v-model="score.b_b1_a" size="small" :style="{ width: '100px' }" />
                                /x，精确0.1，大于10取10
                            </td>
                        </tr>
                        <tr>
                            <td>
                                注意广度
                            </td>
                            <td>
                                B2=
                                <a-input type="number" v-model="score.b_b2_a" size="small" :style="{ width: '100px' }" />
                                /x，精确0.1，大于10取10
                            </td>
                        </tr>
                        <tr>
                            <td>
                                注意稳定
                            </td>
                            <td>
                                1-10：B3=
                                <a-input type="number" v-model="score.b_b3_a" size="small" :style="{ width: '100px' }" />
                                /x
                                <br />
                                1-20：B3=
                                <a-input type="number" v-model="score.b_b3_b" size="small" :style="{ width: '100px' }" />
                                /x
                            </td>
                        </tr>
                        <tr>
                            <td>
                                注意转移
                            </td>
                            <td>
                                B4=
                                <a-input type="number" v-model="score.b_b4_a" size="small" :style="{ width: '100px' }" />
                                /x
                            </td>
                        </tr>
                        <tr>
                            <td>
                                左右脑协调
                            </td>
                            <td>
                                B5=
                                <a-input type="number" v-model="score.b_b5_a" size="small" :style="{ width: '100px' }" />
                                /x
                            </td>
                        </tr>
                        <tr>
                            <td>
                                视觉专注
                            </td>
                            <td>
                                3*3：B6=
                                <a-input type="number" v-model="score.b_b6_a" size="small" :style="{ width: '100px' }" />
                                /x
                                <br />
                                4*4：B6=
                                <a-input type="number" v-model="score.b_b6_b" size="small" :style="{ width: '100px' }" />
                                /x
                                <br />
                                5*5：B6=
                                <a-input type="number" v-model="score.b_b6_c" size="small" :style="{ width: '100px' }" />
                                /x
                            </td>
                        </tr>
                        <tr>
                            <td>
                                听觉专注
                            </td>
                            <td>
                                B7=
                                <a-input type="number" v-model="score.b_b7_a" size="small" :style="{ width: '100px' }" />
                                /x
                            </td>
                        </tr>
                    </table>
                </a-form-model>

                <a-button type="primary" icon="save" @click="execSaveScore" :style="{ marginTop: '10px' }">
                    更新配置
                </a-button>
            </a-tab-pane>
            <a-tab-pane key="2" tab="测评资源" force-render>
                <a-form-model :model="res">
                    <table class="bordered">
                        <thead>
                            <tr>
                                <th style="width: 20%;">
                                    配置项
                                </th>
                                <th style="width: 80%;">
                                    配置值
                                </th>
                            </tr>
                        </thead>
                        <tr>
                            <td>
                                资源版本
                            </td>
                            <td>
                                <a-input type="number" v-model="res.r_ver" :style="{ width: '90%' }" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                下载地址
                            </td>
                            <td>
                                <a-input v-model="res.r_url" :style="{ width: '90%' }" />
                            </td>
                        </tr>
                    </table>
                </a-form-model>

                <a-button type="primary" icon="save" @click="execSaveRes" :style="{ marginTop: '10px' }">
                    更新配置
                </a-button>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
export default {
    name: 'AteConfig',
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        }
    },
    data() {
        return {
            score: {},
            res: {}
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '测评配置'])
        this.doLoadRes()
        this.doLoadScore()
    },
    methods: {
        onTabsChange(key) {
            if (key === '1') {
                this.doLoadScore()
            } else if (key === '2') {
                this.doLoadRes()
            }
        },
        doLoadScore() {
            this.$http
                .get('/cts/ate/config/score/info', {
                    params: {
                        _: new Date().getTime()
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.score = result.data
                })
        },
        doLoadRes() {
            this.$http
                .get('/cts/ate/config/resource/info', {
                    params: {
                        _: new Date().getTime()
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.res = result.data
                })
        },
        doSaveScore() {
            this.$http.post('/cts/ate/config/score/save', this.score).then(result => {
                if (result.code === 0) {
                    this.doLoadScore()
                    this.$message.success('更新成功')
                }
            })
        },
        execSaveScore() {
            this.$confirm({
                title: '是否更新测评计分规则配置信息',
                okText: '更新',
                okType: 'primary',
                cancelText: '取消',
                onOk: () => {
                    this.doSaveScore()
                }
            })
        },
        doSaveRes() {
            this.$http.post('/cts/ate/config/resource/save', this.res).then(result => {
                if (result.code === 0) {
                    this.doLoadRes()
                    this.$message.success('更新成功')
                }
            })
        },
        execSaveRes() {
            this.$confirm({
                title: '是否更新测评资源配置信息',
                okText: '更新',
                okType: 'primary',
                cancelText: '取消',
                onOk: () => {
                    this.doSaveRes()
                }
            })
        }
    }
}
</script>

<style scoped>
table {
    *border-collapse: collapse; /* IE7 and lower */
    border-spacing: 0;
    width: 100%;
}
.bordered {
    border: solid #ccc 1px;
    -moz-border-radius: 6px;
    -webkit-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-shadow: 0 1px 1px #ccc;
    -moz-box-shadow: 0 1px 1px #ccc;
    box-shadow: 0 1px 1px #ccc;
}
.bordered tr {
    -o-transition: all 0.1s ease-in-out;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    -ms-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
}
.bordered .highlight,
.bordered tr:hover {
    background: #fbf8e9;
}
.bordered td,
.bordered th {
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    padding: 10px;
    text-align: left;
}
.bordered th {
    background-color: #dce9f9;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#ebf3fc), to(#dce9f9));
    background-image: -webkit-linear-gradient(top, #ebf3fc, #dce9f9);
    background-image: -moz-linear-gradient(top, #ebf3fc, #dce9f9);
    background-image: -ms-linear-gradient(top, #ebf3fc, #dce9f9);
    background-image: -o-linear-gradient(top, #ebf3fc, #dce9f9);
    background-image: linear-gradient(to top, #ebf3fc, #dce9f9);
    filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0, startColorstr=#ebf3fc, endColorstr=#dce9f9);
    -ms-filter: 'progid:DXImageTransform.Microsoft.gradient (GradientType=0, startColorstr=#ebf3fc, endColorstr=#dce9f9)';
    -webkit-box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
    -moz-box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
    border-top: none;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}
.bordered td:first-child,
.bordered th:first-child {
    border-left: none;
}
.bordered th:first-child {
    -moz-border-radius: 6px 0 0 0;
    -webkit-border-radius: 6px 0 0 0;
    border-radius: 6px 0 0 0;
}
.bordered th:last-child {
    -moz-border-radius: 0 6px 0 0;
    -webkit-border-radius: 0 6px 0 0;
    border-radius: 0 6px 0 0;
}
.bordered tr:last-child td:first-child {
    -moz-border-radius: 0 0 0 6px;
    -webkit-border-radius: 0 0 0 6px;
    border-radius: 0 0 0 6px;
}
.bordered tr:last-child td:last-child {
    -moz-border-radius: 0 0 6px 0;
    -webkit-border-radius: 0 0 6px 0;
    border-radius: 0 0 6px 0;
}
.config-val {
    color: red;
}
</style>
